import React from "react"

export default function HeaderMenu({menu}) 
{     
    return(
        <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
            <ul className="navbar-nav">
            {
                menu.filter(mI => (mI.drupal_parent_menu_item == null)).map((menuItem, mainindex) => 
                {
                    const uri =  menuItem.link.uri.replace('internal:', ''); 
                    const liClasses = uri === '#' ? 'nav-item dropdown' : 'nav-item';   
                    const aClasses = uri === '#' ? 'nav-link dropdown-toggle' : 'nav-link'; 
                    const toggle = uri === '#' ? 'dropdown' : '';

                    const submenu = (uri) =>
                    {
                        if(uri !== '#')
                        {
                            return;
                        }

                        return(
                            <ul key={mainindex} className="dropdown-menu dropdown-menu-right" aria-labelledby={menuItem.drupal_id}>
                            {
                                menu.filter(mI => (mI.drupal_parent_menu_item === 'menu_link_content:' + menuItem.drupal_id)).map((submenuItem, index) => 
                                {
                                    const uri =  submenuItem.link.uri.replace('internal:', '');
                                    
                                    return(

                                        <li key={index}><a className="dropdown-item" href={uri}>{submenuItem.title}</a></li>
                                    )
                                })
                            }
                            </ul>
                        )
                    }
                    
                    return(
                        <li className={liClasses} key={menuItem.drupal_id} >
                            <a className={aClasses} href={uri} role="button" data-toggle={toggle} aria-expanded="false">{menuItem.title}</a>
                            {submenu(uri)}
                        </li>  
                   )                                    
                })
            }
            </ul>
        </div>
    )
}